import React from "react";

const Monitoring = () => {
  return (
    <div style={{ padding: "20px", height: "fit-content" }}>
      <h2
        style={{
          marginBottom: "10px",
          fontSize: "15px",
          fontWeight: 500,
          color: "#18242D",
        }}
      >
        Monitoring
      </h2>

      <div
        style={{
          display: "flex",
          backgroundColor: "#FFFFFF",
          borderRadius: "0.375rem",
          padding: "1rem",
          gap: "1rem",
          border: "1px solid #e5e7eb",
        }}
      >
        {/* Left Partition */}
        <div style={{ flex: 1, position: "relative", padding: "0 10px" }}>
          <div
            style={{
              position: "absolute",
              top: "10px",
              left: "10px",
              fontSize: "13px",
              fontWeight: 400,
              color: "#18242D",
            }}
          >
            Defects
            <div
              style={{
                fontSize: "14px",
                fontWeight: 550,
                color: "#18242D",
                marginTop: "2px",
              }}
            >
              3
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              fontSize: "13px",
              fontWeight: 400,
              color: "#18242D",
            }}
          >
            Power Loss
            <div
              style={{
                fontSize: "14px",
                fontWeight: 550,
                color: "#18242D",
                marginTop: "2px",
              }}
            >
              120 kW
            </div>
          </div>

          <div
            style={{
              marginTop: "120px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
              <label
                style={{
                  fontSize: "13px",
                  color: "#18242D",
                  marginBottom: "5px",
                  fontWeight: 400,
                  textAlign: "left",
                }}
              >
                Image Set 1
              </label>
              <select
                style={{
                  width: "100%",
                  padding: "5px 10px",
                  borderRadius: "0.25rem",
                  border: "1px solid #d1d5db",
                  fontSize: "13px",
                  color: "#18242D",
                  backgroundColor: "#F4F4F6",
                }}
              >
                <option>Select Image Set</option>
                <option>Image Set 1</option>
                <option>Image Set 2</option>
              </select>
            </div>
          </div>
        </div>

        {/* Vertical separator */}
        <div style={{ width: "1px", backgroundColor: "#e5e7eb" }} />

        {/* Right Partition */}
        <div style={{ flex: 1, position: "relative", padding: "0 10px" }}>
          <div
            style={{
              position: "absolute",
              top: "10px",
              left: "10px",
              fontSize: "13px",
              fontWeight: 400,
              color: "#18242D",
            }}
          >
            Defects
            <div
              style={{
                fontSize: "14px",
                fontWeight: 550,
                color: "#18242D",
                marginTop: "2px",
              }}
            >
              5
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              fontSize: "13px",
              fontWeight: 400,
              color: "#18242D",
            }}
          >
            Power Loss
            <div
              style={{
                fontSize: "14px",
                fontWeight: 550,
                color: "#18242D",
                marginTop: "2px",
              }}
            >
              80 kW
            </div>
          </div>

          <div
            style={{
              marginTop: "120px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", width: "50%" }}>
              <label
                style={{
                  fontSize: "13px",
                  color: "#18242D",
                  marginBottom: "5px",
                  fontWeight: 400,
                  textAlign: "left",
                }}
              >
                Image Set 2
              </label>
              <select
                style={{
                  width: "100%",
                  padding: "5px 10px",
                  borderRadius: "0.25rem",
                  border: "1px solid #d1d5db",
                  fontSize: "13px",
                  color: "#18242D",
                  backgroundColor: "#F4F4F6",
                }}
              >
                <option>Select Image Set</option>
                <option>Image Set 1</option>
                <option>Image Set 2</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Monitoring;
